type CrosshairProps = {
  centerX: number;
  centerY: number;
  gap?: number;
  color?: string;
  strokeWidth?: number;
};

export default function Crosshair({
  centerX,
  centerY,
  gap = 20,
  color = '#0056b2',
  strokeWidth = 1,
}: CrosshairProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 99,
      }}
    >
      {/* 수평선 위쪽 */}
      <line
        x1={0}
        y1={centerY}
        x2={centerX - gap / 2}
        y2={centerY}
        stroke={'yellow'}
        strokeWidth={strokeWidth}
      />
      {/* 수평선 아래쪽 */}
      <line
        x1={centerX + gap / 2}
        y1={centerY}
        x2="100%"
        y2={centerY}
        stroke={'yellow'}
        strokeWidth={strokeWidth}
      />
      {/* 수직선 왼쪽 */}
      <line
        x1={centerX}
        y1={0}
        x2={centerX}
        y2={centerY - gap / 2}
        stroke={'yellow'}
        strokeWidth={strokeWidth}
      />
      {/* 수직선 오른쪽 */}
      <line
        x1={centerX}
        y1={centerY + gap / 2}
        x2={centerX}
        y2="100%"
        stroke={'yellow'}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
